!(function () {
    let e = navigator.connection?.saveData,
        t = navigator.deviceMemory || 4;
    if (e || t < 2) {
        console.info(
            "\uD83D\uDCA1 Skipping Hotjar: data saver ON or low device memory"
        );
        return;
    }
    let r = !1;
    function o() {
        if (r) return;
        (r = !0),
            (window.hj =
                window.hj ||
                function (...e) {
                    (window.hj.q = window.hj.q || []).push(e);
                }),
            (window._hjSettings = { hjid: 5044455, hjsv: 6 });
        let e = document.createElement("script");
        (e.src = "https://static.hotjar.com/c/hotjar-5044455.js?sv=6"),
            (e.async = !0),
            (e.onerror = () => console.error("❌ Failed to load Hotjar script")),
            document.head.appendChild(e);
    }
    if ("requestIdleCallback" in window) requestIdleCallback(o, { timeout: 8e3 });
    else {
        let a = ["mousemove", "touchstart", "scroll", "keydown"],
            i = () => {
                a.forEach((e) => window.removeEventListener(e, i)), o();
            };
        a.forEach((e) => window.addEventListener(e, i, { passive: !0 }));
    }
})();
